import store from '@/store/store'

export const SECTION_TRANSLATIONS = {
  CAS: { th: 'ศูนย์บริการวิชาการ', en: 'Academic Service Center' },
  ศูนย์บริการวิชาการ: { th: 'ศูนย์บริการวิชาการ', en: 'Academic Service Center' },
  'Academic Service Center': { th: 'ศูนย์บริการวิชาการ', en: 'Academic Service Center' },

  CDTI: { th: 'ศูนย์เทคโนโลยีดิจิทัลและสารสนเทศ', en: 'Center for Digital Technology and Information' },
  ศูนย์เทคโนโลยีดิจิทัลและสารสนเทศ: { th: 'ศูนย์เทคโนโลยีดิจิทัลและสารสนเทศ', en: 'Center for Digital Technology and Information' },
  'Center for Digital Technology and Information': { th: 'ศูนย์เทคโนโลยีดิจิทัลและสารสนเทศ', en: 'Center for Digital Technology and Information' },

  BUILDING: { th: 'ส่วนอาคารสถานที่', en: 'Division of Buildings and Grounds' },
  ส่วนอาคารสถานที่: { th: 'ส่วนอาคารสถานที่', en: 'Division of Buildings and Grounds' },
  ส่วนอาคารและสถานที่: { th: 'ส่วนอาคารสถานที่', en: 'Division of Buildings and Grounds' },
  'Division of Buildings and Grounds': { th: 'ส่วนอาคารสถานที่', en: 'Division of Buildings and Grounds' },

  ASSET: { th: 'สำนักงานจัดการทรัพย์สินและรายได้', en: 'Property and Revenue Management Office' },
  สำนักงานจัดการทรัพย์สินและรายได้: { th: 'สำนักงานจัดการทรัพย์สินและรายได้', en: 'Property and Revenue Management Office' },
  'Property and Revenue Management Office': { th: 'สำนักงานจัดการทรัพย์สินและรายได้', en: 'Property and Revenue Management Office' },

  'อื่น ๆ': { th: 'อื่น ๆ', en: 'Others' },
  อื่นๆ: { th: 'อื่น ๆ', en: 'Others' },
  Others: { th: 'อื่น ๆ', en: 'Others' },
  Other: { th: 'อื่น ๆ', en: 'Others' },
}

export const DEPARTMENT_TRANSLATIONS = {
  'AV-CLASS': { th: 'ฝ่ายบริการโสตทัศนูปกรณ์และห้องเรียนอัจฉริยะ', en: 'Audio-Visual Service and Smart Classroom Division' },
  ฝ่ายบริการโสตทัศนูปกรณ์และห้องเรียนอัจฉริยะ: { th: 'ฝ่ายบริการโสตทัศนูปกรณ์และห้องเรียนอัจฉริยะ', en: 'Audio-Visual Service and Smart Classroom Division' },
  'Audio-Visual Service and Smart Classroom Division': { th: 'ฝ่ายบริการโสตทัศนูปกรณ์และห้องเรียนอัจฉริยะ', en: 'Audio-Visual Service and Smart Classroom Division' },

  'IT-SUP': { th: 'ฝ่ายบริการและสนับสนุนเทคนิค', en: 'Technical Service and Support Division' },
  ฝ่ายบริการและสนับสนุนเทคนิค: { th: 'ฝ่ายบริการและสนับสนุนเทคนิค', en: 'Technical Service and Support Division' },
  'Technical Service and Support Division': { th: 'ฝ่ายบริการและสนับสนุนเทคนิค', en: 'Technical Service and Support Division' },

  'IT-NET': { th: 'ฝ่ายเครือข่ายและระบบสื่อสาร', en: 'Network and Communication Systems Division' },
  ฝ่ายเครือข่ายและระบบสื่อสาร: { th: 'ฝ่ายเครือข่ายและระบบสื่อสาร', en: 'Network and Communication Systems Division' },
  'Network and Communication Systems Division': { th: 'ฝ่ายเครือข่ายและระบบสื่อสาร', en: 'Network and Communication Systems Division' },

  'IT-DEV': { th: 'ฝ่ายพัฒนาระบบสารสนเทศ', en: 'Information System Development Division' },
  ฝ่ายพัฒนาระบบสารสนเทศ: { th: 'ฝ่ายพัฒนาระบบสารสนเทศ', en: 'Information System Development Division' },
  'Information System Development Division': { th: 'ฝ่ายพัฒนาระบบสารสนเทศ', en: 'Information System Development Division' },

  'ENG-MEP': { th: 'ฝ่ายวิศวกรรมระบบและสุขาภิบาล', en: 'Systems Engineering and Sanitation Division' },
  ฝ่ายวิศวกรรมระบบและสุขาภิบาล: { th: 'ฝ่ายวิศวกรรมระบบและสุขาภิบาล', en: 'Systems Engineering and Sanitation Division' },
  'Systems Engineering and Sanitation Division': { th: 'ฝ่ายวิศวกรรมระบบและสุขาภิบาล', en: 'Systems Engineering and Sanitation Division' },

  CIVIL: { th: 'ฝ่ายอาคาร โครงสร้าง และครุภัณฑ์', en: 'Building, Structure and Equipment Division' },
  'ฝ่ายอาคาร โครงสร้าง และครุภัณฑ์': { th: 'ฝ่ายอาคาร โครงสร้าง และครุภัณฑ์', en: 'Building, Structure and Equipment Division' },
  'Building, Structure and Equipment Division': { th: 'ฝ่ายอาคาร โครงสร้าง และครุภัณฑ์', en: 'Building, Structure and Equipment Division' },

  'ENV-SAFE': { th: 'ฝ่ายภูมิทัศน์ สิ่งแวดล้อม และความปลอดภัย', en: 'Landscape, Environment and Safety Division' },
  'ฝ่ายภูมิทัศน์ สิ่งแวดล้อม และความปลอดภัย': { th: 'ฝ่ายภูมิทัศน์ สิ่งแวดล้อม และความปลอดภัย', en: 'Landscape, Environment and Safety Division' },
  'Landscape, Environment and Safety Division': { th: 'ฝ่ายภูมิทัศน์ สิ่งแวดล้อม และความปลอดภัย', en: 'Landscape, Environment and Safety Division' },

  'ASSET-ACCOM': { th: 'ศูนย์บริการที่พัก', en: 'Accommodation Service Center' },
  ศูนย์บริการที่พัก: { th: 'ศูนย์บริการที่พัก', en: 'Accommodation Service Center' },
  'Accommodation Service Center': { th: 'ศูนย์บริการที่พัก', en: 'Accommodation Service Center' },

  'ASSET-BOOK': { th: 'ศูนย์หนังสือ', en: 'Bookstore Center' },
  ศูนย์หนังสือ: { th: 'ศูนย์หนังสือ', en: 'Bookstore Center' },
  'Bookstore Center': { th: 'ศูนย์หนังสือ', en: 'Bookstore Center' },

  'ASSET-FOOD': { th: 'ศูนย์บริการอาหาร', en: 'Food Service Center' },
  ศูนย์บริการอาหาร: { th: 'ศูนย์บริการอาหาร', en: 'Food Service Center' },
  'Food Service Center': { th: 'ศูนย์บริการอาหาร', en: 'Food Service Center' },

  'ASSET-RENT': { th: 'งานพื้นที่เช่า', en: 'Rental Space Operations' },
  งานพื้นที่เช่า: { th: 'งานพื้นที่เช่า', en: 'Rental Space Operations' },
  'Rental Space Operations': { th: 'งานพื้นที่เช่า', en: 'Rental Space Operations' },
}

export const JOB_TYPE_TRANSLATIONS = {
  โสตทัศนูปกรณ์และห้องประชุม: { th: 'โสตทัศนูปกรณ์และห้องประชุม', en: 'Audio-Visual Equipment & Meeting Rooms' },
  'Audio-Visual Equipment & Meeting Rooms': { th: 'โสตทัศนูปกรณ์และห้องประชุม', en: 'Audio-Visual Equipment & Meeting Rooms' },

  อุปกรณ์ห้องเรียนและการสอนออนไลน์: { th: 'อุปกรณ์ห้องเรียนและการสอนออนไลน์', en: 'Classroom Equipment & Online Teaching Systems' },
  'Classroom Equipment & Online Teaching Systems': { th: 'อุปกรณ์ห้องเรียนและการสอนออนไลน์', en: 'Classroom Equipment & Online Teaching Systems' },

  คอมพิวเตอร์และอุปกรณ์: { th: 'คอมพิวเตอร์และอุปกรณ์', en: 'Computers & Equipment' },
  'Computers & Equipment': { th: 'คอมพิวเตอร์และอุปกรณ์', en: 'Computers & Equipment' },

  เครื่องพิมพ์และสแกนเนอร์: { th: 'เครื่องพิมพ์และสแกนเนอร์', en: 'Printers & Scanners' },
  'Printers & Scanners': { th: 'เครื่องพิมพ์และสแกนเนอร์', en: 'Printers & Scanners' },

  'บัญชีผู้ใช้ อีเมล และ Google Workspace': { th: 'บัญชีผู้ใช้ อีเมล และ Google Workspace', en: 'User Accounts, Email & Google Workspace' },
  'User Accounts, Email & Google Workspace': { th: 'บัญชีผู้ใช้ อีเมล และ Google Workspace', en: 'User Accounts, Email & Google Workspace' },

  อินเทอร์เน็ตและเครือข่าย: { th: 'อินเทอร์เน็ตและเครือข่าย', en: 'Internet & Network' },
  'ระบบเครือข่ายและอินเทอร์เน็ต': { th: 'อินเทอร์เน็ตและเครือข่าย', en: 'Internet & Network' },
  'Internet & Network': { th: 'อินเทอร์เน็ตและเครือข่าย', en: 'Internet & Network' },

  'CABLE TV': { th: 'เคเบิลทีวี (Cable TV)', en: 'Cable TV' },
  'Cable TV': { th: 'เคเบิลทีวี (Cable TV)', en: 'Cable TV' },
  'เคเบิลทีวี (Cable TV)': { th: 'เคเบิลทีวี (Cable TV)', en: 'Cable TV' },
  'เคเบิลทีวี': { th: 'เคเบิลทีวี (Cable TV)', en: 'Cable TV' },

  กล้องวงจรปิดและระบบสื่อสาร: { th: 'กล้องวงจรปิดและระบบสื่อสาร', en: 'CCTV & Communication Systems' },
  'CCTV & Communication Systems': { th: 'กล้องวงจรปิดและระบบสื่อสาร', en: 'CCTV & Communication Systems' },

  ระบบสารสนเทศและซอฟต์แวร์: { th: 'ระบบสารสนเทศและซอฟต์แวร์', en: 'Information Systems & Software' },
  'Information Systems & Software': { th: 'ระบบสารสนเทศและซอฟต์แวร์', en: 'Information Systems & Software' },

  ไฟฟ้าและแสงสว่าง: { th: 'ไฟฟ้าและแสงสว่าง', en: 'Electricity & Lighting' },
  'Electricity & Lighting': { th: 'ไฟฟ้าและแสงสว่าง', en: 'Electricity & Lighting' },

  ประปาและสุขาภิบาล: { th: 'ประปาและสุขาภิบาล', en: 'Plumbing & Sanitation' },
  'Plumbing & Sanitation': { th: 'ประปาและสุขาภิบาล', en: 'Plumbing & Sanitation' },

  เครื่องปรับอากาศและระบบเครื่องกล: { th: 'เครื่องปรับอากาศและระบบเครื่องกล', en: 'Air Conditioning & Mechanical Systems' },
  'Air Conditioning & Mechanical Systems': { th: 'เครื่องปรับอากาศและระบบเครื่องกล', en: 'Air Conditioning & Mechanical Systems' },

  ลิฟต์และประตูอัตโนมัติ: { th: 'ลิฟต์และประตูอัตโนมัติ', en: 'Elevators & Automatic Doors' },
  'Elevators & Automatic Doors': { th: 'ลิฟต์และประตูอัตโนมัติ', en: 'Elevators & Automatic Doors' },

  โทรศัพท์ภายใน: { th: 'โทรศัพท์ภายใน', en: 'Internal Telephone' },
  'Internal Telephone': { th: 'โทรศัพท์ภายใน', en: 'Internal Telephone' },

  อาคารและงานโยธา: { th: 'อาคารและงานโยธา', en: 'Buildings & Civil Works' },
  'Buildings & Civil Works': { th: 'อาคารและงานโยธา', en: 'Buildings & Civil Works' },

  เฟอร์นิเจอร์และครุภัณฑ์ทั่วไป: { th: 'เฟอร์นิเจอร์และครุภัณฑ์ทั่วไป', en: 'Furniture & General Equipment' },
  'Furniture & General Equipment': { th: 'เฟอร์นิเจอร์และครุภัณฑ์ทั่วไป', en: 'Furniture & General Equipment' },

  พื้นที่ภายนอกและภูมิทัศน์: { th: 'พื้นที่ภายนอกและภูมิทัศน์', en: 'Outdoor Area & Landscape' },
  'Outdoor Area & Landscape': { th: 'พื้นที่ภายนอกและภูมิทัศน์', en: 'Outdoor Area & Landscape' },

  ความสะอาดและสิ่งแวดล้อม: { th: 'ความสะอาดและสิ่งแวดล้อม', en: 'Cleaning & Environment' },
  'Cleaning & Environment': { th: 'ความสะอาดและสิ่งแวดล้อม', en: 'Cleaning & Environment' },

  ความปลอดภัยและอัคคีภัย: { th: 'ความปลอดภัยและอัคคีภัย', en: 'Safety & Fire Protection' },
  'Safety & Fire Protection': { th: 'ความปลอดภัยและอัคคีภัย', en: 'Safety & Fire Protection' },

  ซ่อมบำรุงระบบไฟฟ้า: { th: 'ซ่อมบำรุงระบบไฟฟ้า', en: 'Electrical System Maintenance' },
  'Electrical System Maintenance': { th: 'ซ่อมบำรุงระบบไฟฟ้า', en: 'Electrical System Maintenance' },

  ซ่อมบำรุงระบบโทรศัพท์: { th: 'ซ่อมบำรุงระบบโทรศัพท์', en: 'Telephone System Maintenance' },
  'Telephone System Maintenance': { th: 'ซ่อมบำรุงระบบโทรศัพท์', en: 'Telephone System Maintenance' },

  'ซ่อมบำรุงระบบ CCTV': { th: 'ซ่อมบำรุงระบบ CCTV', en: 'CCTV System Maintenance' },
  'CCTV System Maintenance': { th: 'ซ่อมบำรุงระบบ CCTV', en: 'CCTV System Maintenance' },

  'ซ่อมบำรุงงานโยธา-สถาปัตย์': { th: 'ซ่อมบำรุงงานโยธา-สถาปัตย์', en: 'Civil and Architectural Maintenance' },
  'Civil and Architectural Maintenance': { th: 'ซ่อมบำรุงงานโยธา-สถาปัตย์', en: 'Civil and Architectural Maintenance' },

  'ซ่อมบำรุงครุภัณฑ์-วัสดุ': { th: 'ซ่อมบำรุงครุภัณฑ์-วัสดุ', en: 'Equipment and Material Maintenance' },
  'Equipment and Material Maintenance': { th: 'ซ่อมบำรุงครุภัณฑ์-วัสดุ', en: 'Equipment and Material Maintenance' },

  'ซ่อมบำรุงระบบปรับอากาศ,ระบบลิฟท์,เครื่องทำน้ำเย็น': { th: 'ซ่อมบำรุงระบบปรับอากาศ,ระบบลิฟท์,เครื่องทำน้ำเย็น', en: 'Air Conditioning, Elevators & Water Coolers Maintenance' },
  'Air Conditioning, Elevators & Water Coolers Maintenance': { th: 'ซ่อมบำรุงระบบปรับอากาศ,ระบบลิฟท์,เครื่องทำน้ำเย็น', en: 'Air Conditioning, Elevators & Water Coolers Maintenance' },

  'ซ่อมบำรุงระบบประปา,ระบบสุขาภิบาล': { th: 'ซ่อมบำรุงระบบประปา,ระบบสุขาภิบาล', en: 'Plumbing & Sanitation Maintenance' },
  'Plumbing & Sanitation Maintenance': { th: 'ซ่อมบำรุงระบบประปา,ระบบสุขาภิบาล', en: 'Plumbing & Sanitation Maintenance' },

  'อื่น ๆ': { th: 'อื่น ๆ', en: 'Others' },
  อื่นๆ: { th: 'อื่น ๆ', en: 'Others' },
  Others: { th: 'อื่น ๆ', en: 'Others' },
  Other: { th: 'อื่น ๆ', en: 'Others' },
}

function resolveLang(lang) {
  if (lang === 'en' || lang === 'th') return lang
  if (store && store.state && store.state.locale && store.state.locale.lang) {
    return store.state.locale.lang
  }
  return 'th'
}

export const DYNAMIC_SECTION_TRANSLATIONS = {};
export const DYNAMIC_DEPARTMENT_TRANSLATIONS = {};
export const DYNAMIC_JOB_TYPE_TRANSLATIONS = {};

export function registerSectionObject(sec) {
  if (!sec || typeof sec !== 'object') return;
  const th = (typeof sec.nameTh === 'string' && sec.nameTh.trim()) || sec.departmentName || sec.name || '';
  const en = (typeof sec.nameEn === 'string' && sec.nameEn.trim()) ? sec.nameEn.trim() : null;
  const entry = { th: th || (sec.code || ''), en: en || th || (sec.code || '') };
  if (sec.departmentName) DYNAMIC_SECTION_TRANSLATIONS[sec.departmentName.trim()] = entry;
  if (sec.name) DYNAMIC_SECTION_TRANSLATIONS[sec.name.trim()] = entry;
  if (sec.code) DYNAMIC_SECTION_TRANSLATIONS[sec.code.trim()] = entry;
  if (sec.id || sec._id) DYNAMIC_SECTION_TRANSLATIONS[String(sec.id || sec._id)] = entry;

  if (Array.isArray(sec.subCategories)) {
    sec.subCategories.forEach(registerJobTypeObject);
  }
  if (Array.isArray(sec.departments)) {
    sec.departments.forEach(registerDepartmentObject);
  }
}

export function registerDepartmentObject(dept) {
  if (!dept || typeof dept !== 'object') return;
  const th = (typeof dept.nameTh === 'string' && dept.nameTh.trim()) || dept.name || '';
  const en = (typeof dept.nameEn === 'string' && dept.nameEn.trim()) ? dept.nameEn.trim() : null;
  const entry = { th: th || (dept.code || ''), en: en || th || (dept.code || '') };
  if (dept.name) DYNAMIC_DEPARTMENT_TRANSLATIONS[dept.name.trim()] = entry;
  if (dept.code) DYNAMIC_DEPARTMENT_TRANSLATIONS[dept.code.trim()] = entry;
  if (dept.id || dept._id) DYNAMIC_DEPARTMENT_TRANSLATIONS[String(dept.id || dept._id)] = entry;
}

export function registerJobTypeObject(job) {
  if (!job || typeof job !== 'object') return;
  const th = (typeof job.nameTh === 'string' && job.nameTh.trim()) || job.name || job.title || '';
  const en = (typeof job.nameEn === 'string' && job.nameEn.trim()) ? job.nameEn.trim() : null;
  const entry = { th, en: en || th };
  if (job.name) DYNAMIC_JOB_TYPE_TRANSLATIONS[job.name.trim()] = entry;
  if (job.title) DYNAMIC_JOB_TYPE_TRANSLATIONS[job.title.trim()] = entry;
  if (job.id || job._id) DYNAMIC_JOB_TYPE_TRANSLATIONS[String(job.id || job._id)] = entry;
  if (Array.isArray(job.previousNames)) {
    job.previousNames.forEach(pn => {
      if (pn && typeof pn === 'string') {
        DYNAMIC_JOB_TYPE_TRANSLATIONS[pn.trim()] = entry;
      }
    });
  }
}

export function registerCategoryTranslations({ sections = [], departments = [], subCategories = [] } = {}) {
  if (Array.isArray(sections)) sections.forEach(registerSectionObject);
  if (Array.isArray(departments)) departments.forEach(registerDepartmentObject);
  if (Array.isArray(subCategories)) subCategories.forEach(registerJobTypeObject);
}

function legacyName(value) {
  return value && typeof value === 'object' ? value.departmentName || value.name || value.code || '' : value
}

export function translateSection(nameOrCode, lang) {
  if (nameOrCode && typeof nameOrCode === 'object') {
    registerSectionObject(nameOrCode);
    const l = resolveLang(lang);
    if (l === 'en') {
      if (typeof nameOrCode.nameEn === 'string' && nameOrCode.nameEn.trim()) {
        return nameOrCode.nameEn.trim();
      }
    } else {
      if (typeof nameOrCode.nameTh === 'string' && nameOrCode.nameTh.trim()) {
        return nameOrCode.nameTh.trim();
      }
    }
  }

  const rawKey = legacyName(nameOrCode);
  if (!rawKey) return '-';
  const l = resolveLang(lang);
  const key = String(rawKey).trim();

  const dynamic = DYNAMIC_SECTION_TRANSLATIONS[key];
  if (dynamic && dynamic[l]) return dynamic[l];

  const entry = SECTION_TRANSLATIONS[key];
  if (entry) return entry[l] || entry.th;
  return key;
}

export function translateDepartment(nameOrCode, lang) {
  if (nameOrCode && typeof nameOrCode === 'object') {
    registerDepartmentObject(nameOrCode);
    const l = resolveLang(lang);
    if (l === 'en') {
      if (typeof nameOrCode.nameEn === 'string' && nameOrCode.nameEn.trim()) {
        return nameOrCode.nameEn.trim();
      }
    } else {
      if (typeof nameOrCode.nameTh === 'string' && nameOrCode.nameTh.trim()) {
        return nameOrCode.nameTh.trim();
      }
    }
  }

  const rawKey = legacyName(nameOrCode);
  if (!rawKey) return '-';
  const l = resolveLang(lang);
  const key = String(rawKey).trim();

  const dynamic = DYNAMIC_DEPARTMENT_TRANSLATIONS[key];
  if (dynamic && dynamic[l]) return dynamic[l];

  const baseName = key.replace(/\s*\([^)]*\)\s*$/, '').trim();
  const entry = DEPARTMENT_TRANSLATIONS[key] || DEPARTMENT_TRANSLATIONS[baseName];
  if (entry) return entry[l] || entry.th;
  return key;
}

export function translateJobType(name, lang) {
  if (name && typeof name === 'object') {
    registerJobTypeObject(name);
    const l = resolveLang(lang);
    if (l === 'en') {
      if (typeof name.nameEn === 'string' && name.nameEn.trim()) {
        return name.nameEn.trim();
      }
    } else {
      if (typeof name.nameTh === 'string' && name.nameTh.trim()) {
        return name.nameTh.trim();
      }
    }
  }

  const rawKey = legacyName(name);
  if (!rawKey) return '-';
  const l = resolveLang(lang);
  const key = String(rawKey).trim();

  const dynamic = DYNAMIC_JOB_TYPE_TRANSLATIONS[key];
  if (dynamic && dynamic[l]) return dynamic[l];

  const entry = JOB_TYPE_TRANSLATIONS[key];
  if (entry) return entry[l] || entry.th;
  return key;
}
